module.exports = ".maxlength-counter {\n    font-size: 14px;\n    color: #8e8fa6;\n    text-align: end;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-textarea-input/happy-textarea-input.component.css
// module id = ./src/app/shared/components/happy/happy-textarea-input/happy-textarea-input.component.css
// module chunks = main